import { Component } from "@angular/core";

@Component({
        standalone: false,
    templateUrl: "./client.response.component.html",
})
export class ClientResponsePage {
    constructor() {}
}
